export default __webpack_public_path__ + "static/media/alert-vehicle.1eb098d8.svg";